
    <section class="cmn-innerpage-wrapper page-not-found">
        <img src="assets/images/404.jpg" alt="Page Not Found">
    </section>
